var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0m11.792 16.45c.403-1.616-.616-2.348-1.672-1.869l-23.118 8.914c-1.578.633-1.568 1.513-.287 1.905l5.933 1.852 13.734-8.665c.648-.393 1.243-.182.755.252l-11.13 10.043L19.6 35c.6 0 .865-.274 1.2-.6l2.883-2.803 5.997 4.43c1.103.61 1.9.294 2.175-1.024z"
  })));
};
export default SvgTelegram;